import { message } from "antd"
import { AuthRequester } from "../globals/configs"
import { ChangePasswordTypes } from "../globals/types"
import { ErrorHandler } from "../utils/error_handler"


var initialData = {
    is_loading: false,
    data: []
}

export const changeAdminPassword = (currentPassword, newPassword) => dispatch => {
    dispatch({
        type: ChangePasswordTypes.OPERATION_IN_PROGRESS,
        is_loading: true,
        data: []
    })

    AuthRequester.post("/admins/passwd", {
        cp: currentPassword,
        np: newPassword
    })
        .then(res => {
            message.success("Password changed successfully")
            dispatch({
                type: ChangePasswordTypes.OPERATION_IN_PROGRESS,
                is_loading: false,
                data: "changed"
            })
        })
        .catch(err => {
            if (err.response) {
                var error = new ErrorHandler().hasError(err.response.data)
                if (error.hasError) {
                    message.error(error.message['errorMessage'])
                }
            }else {
                message.error("Connection Failed")
            }
            dispatch({
                type: ChangePasswordTypes.OPERATION_IN_PROGRESS,
                is_loading: false,
                data: []
            })
        })
}